module.exports = __webpack_public_path__ + "static/AMA20 Finalist Medal_New Brokerage of the Year-e791d0709c1a2b2ee31fccfcfd2225ae.png";